import React, { useEffect, useState } from 'react'

import { Spinner } from '@telavita-core/react-design-kit'

import reservationService, { RestrictionsStatus } from 'services/reservation'

import { FeedbackPatientRestriction } from '../FeedbackPatientRestriction'
import { CreateReservation } from '../CreateReservation'
import { Steps, Reservation } from '../..'
import { Patient } from '../../types'

import * as S from './styles'

interface ChooseReservationProps {
  patient: Patient
  professionalUsername: string
  onChangeStep: (step: Steps) => void
  onCreateReservation: (reservation: Reservation) => void
}

export function ChooseReservation({
  patient,
  professionalUsername,
  onChangeStep,
  onCreateReservation,
}: ChooseReservationProps): JSX.Element {
  const [loading, setLoading] = useState(true)
  const [restriction, setRestriction] = useState<RestrictionsStatus | string>(null)
  const [scheduledScheduleCount, setScheduledScheduleCount] = useState(0)
  
  useEffect(() => {
    async function verifyPatientRestriction() {
      const { restrictionStatus, scheduledScheduleCount } = await reservationService.patientRestrictions({ 
        username: patient.username, 
        planCode: patient.lastSchedulePlanCode 
      })

      const isPatientAlreadyHasSchedule = 
        scheduledScheduleCount > 0 && 
        restrictionStatus === RestrictionsStatus.NO_RESTRICTION
      
      if (isPatientAlreadyHasSchedule) {
        setRestriction(RestrictionsStatus.PATIENT_ALREADY_HAS_SCHEDULE)
        setScheduledScheduleCount(scheduledScheduleCount)
        setLoading(false)
        return
      }

      setRestriction(restrictionStatus)
      setLoading(false)
    }

    void verifyPatientRestriction()
  }, [patient])

  if (loading) {
    return (
      <S.Loading>
        <Spinner />
      </S.Loading>
    )
  }

  function handleContinueWithReservation() {
    setRestriction(RestrictionsStatus.NO_RESTRICTION)
  }

  return (
    <S.ChooseReservationContainer>

      {restriction === RestrictionsStatus.PATIENT_ALREADY_HAS_SCHEDULE && (
        <FeedbackPatientRestriction 
          restriction={restriction}
          patient={patient}
          totalPatientSchedule={scheduledScheduleCount}
          handleContinueWithReservation={handleContinueWithReservation}
        />
      )}

      {restriction === RestrictionsStatus.ONLY_PARTICULAR_PLAN_ALLOW_RESERVATION && (
        <FeedbackPatientRestriction
          restriction={restriction}
          patient={patient}
          handleContinueWithReservation={handleContinueWithReservation}
          showIcon={false}
        />
      )}

      {restriction === RestrictionsStatus.NO_RESTRICTION && (
        <CreateReservation
          patient={patient}
          professionalUsername={professionalUsername}
          onChangeStep={onChangeStep}
          onCreateReservation={onCreateReservation}
        />
      )}

      {restriction === RestrictionsStatus.PATIENT_ALREADY_HAS_RESERVATION && (
        <FeedbackPatientRestriction
          restriction={restriction}
          patient={patient}
        />
      )}

      {restriction === RestrictionsStatus.NO_PLAN_GROUP_ALLOWS_RESERVATION && (
        <FeedbackPatientRestriction
          restriction={restriction}
          patient={patient}
        />
      )}

    </S.ChooseReservationContainer>
  )
}